module.exports = __webpack_public_path__ + "img/icon_yscj.79e6b779.png";